import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=266aac02&"
import script from "./schools.vue?vue&type=script&lang=js&"
export * from "./schools.vue?vue&type=script&lang=js&"
import style0 from "./schools.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "schools.vue"
export default component.exports